import { render, staticRenderFns } from "./doctor-info.vue?vue&type=template&id=464761d2&scoped=true"
import script from "./doctor-info.vue?vue&type=script&lang=ts"
export * from "./doctor-info.vue?vue&type=script&lang=ts"
import style0 from "./doctor-info.vue?vue&type=style&index=0&id=464761d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464761d2",
  null
  
)

export default component.exports